// Filmy dekoracyjne (muted, loop) odtwarzane tylko, gdy są widoczne.
// Markup: <video data-lazy-video preload="metadata" loop muted playsinline> — bez autoplay.
// preload="metadata" pobiera tylko nagłówek pliku (wymiary — brak przesunięć układu),
// cały plik ładuje się dopiero przy play(). Wersje desktop/mobile ukryte przez CSS
// (display:none) nigdy nie są widoczne, więc nigdy się nie odtwarzają ani nie pobierają.
(function () {
  if (window.__nkLazyVideo) return;
  window.__nkLazyVideo = true;

  function play(video) {
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  function init() {
    var videos = document.querySelectorAll('video[data-lazy-video]');
    if (!videos.length) return;

    if (!('IntersectionObserver' in window)) {
      videos.forEach(play);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) play(video);
        else if (!video.paused) video.pause();
      });
    }, { rootMargin: '200px 0px' });

    videos.forEach(function (video) { observer.observe(video); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
